<template>
  <div class="page">
    <v-container fluid>
      <!-- Breadcrumb -->
      <avp-breadcrumbs></avp-breadcrumbs>

      <!-- Filtros -->
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Trilha de Aprendizagem"
              v-model="form.filters.nome"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <avp-select-ano-semestre
            :cols="4"
            :sufix="'do Ciclo'"
            v-model="form.filters"
            all
          ></avp-select-ano-semestre>

          <avp-select-ativo
            :cols="2"
            v-model="form.filters.ativo"
          ></avp-select-ativo>
        </v-row>

        <!-- Botões de ação -->
        <div class="text-center">
          <v-col cols="12">
            <avp-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarTrilhasDeAprendizagem()"
            ></avp-tooltip>
            <avp-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></avp-tooltip>
            <avp-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterTrilhasDeAprendizagem()"
            ></avp-tooltip>
            <v-btn
              color="primary"
              class="ml-2"
              @click="alterarStatusSelecionados()"
            >
              Ativar / Inativar Selecionados
            </v-btn>
          </v-col>
        </div>
      </v-form>

      <!-- Tabela de Trilhas -->
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listTrilhasDeAprendizagem"
        :items-per-page="10"
        :footer-props="$footerProps"
        item-key="id"
      >
        <!-- Checkbox no cabeçalho -->
        <template v-slot:header.selecionado>
          <v-checkbox
            v-model="marcarTodos"
            @change="marcarTodosItens"
            :indeterminate="indeterminate"
          ></v-checkbox>
        </template>

        <!-- Checkbox por linha -->
        <template v-slot:item.selecionado="{ item }">
          <v-checkbox
          :input-value="selecionadosIds.includes(item.id)"
          @change="toggleItem(item.id)"
        />
        </template>

        <!-- Campos da tabela -->
        <template v-slot:[`item.ano`]="{ item }">
          {{ item.ano }}
        </template>
        <template v-slot:[`item.semestre`]="{ item }">
          {{ item.semestre }}
        </template>
        <template v-slot:[`item.trilha`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <avp-label-ativo :ativo="item.ativo"></avp-label-ativo>
        </template>

        <!-- Ações por linha -->
        <template v-slot:[`item.acoes`]="{ item }">
          <avp-tooltip
            :text="'Visualizar Trilha de Aprendizagem'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarTrilhaDeAprendizagem(item)"
          ></avp-tooltip>
          <avp-tooltip
            v-if="item.ativo"
            :text="'Editar Trilha de Aprendizagem'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterTrilhasDeAprendizagem(item)"
          ></avp-tooltip>
          <avp-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'} Trilha de Aprendizagem`"
            :icon="`${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarTrilhaDeAprendizagem(item)"
          ></avp-tooltip>
        </template>
      </v-data-table>

    </v-container>

    <!-- Dialogs -->
    <CadastrarEditarTrilhaDeAprendizagemDialog
      :visible="dialogManterTrilhaDeAprendizagem.visible"
      :content="dialogManterTrilhaDeAprendizagem.content"
      :edit="dialogManterTrilhaDeAprendizagem.edit"
      @onClose="dialogManterTrilhaDeAprendizagem.visible = false"
      @onSave="buscarTrilhasDeAprendizagem()"
    ></CadastrarEditarTrilhaDeAprendizagemDialog>

    <VisualizarTrilhaDeAprendizagemDialog
      :visible="dialogVisualizarTrilhaDeAprendizagem.visible"
      :content="dialogVisualizarTrilhaDeAprendizagem.content"
      @onClose="dialogVisualizarTrilhaDeAprendizagem.visible = false"
    ></VisualizarTrilhaDeAprendizagemDialog>

  </div>
</template>

<script>
import { Dialog, TrilhaDeAprendizagem } from "~/commons/classes";

export default {
  name: "ManterTrilhaDeAprendizagemView",
  components: {
    CadastrarEditarTrilhaDeAprendizagemDialog: () => import("./dialogs/CadastrarEditarTrilhaDeAprendizagemDialog.vue"),
    VisualizarTrilhaDeAprendizagemDialog: () => import("./dialogs/VisualizarTrilhaDeAprendizagemDialog.vue"),
  },
  data: () => ({
    dialogManterTrilhaDeAprendizagem: new Dialog(),
    dialogVisualizarTrilhaDeAprendizagem: new Dialog(),
    form: {
      filters: {
        nome: null,
        ano: null,
        semestre: null,
        ativo: null,
      },
      lists: {
        listTrilhasDeAprendizagem: [],
      }
    },
    marcarTodos: false,
    headers: [
      { text: "", value: "selecionado", align: "center" },
      { text: "Ano", align: "center", value: "ano" },
      { text: "Semestre", align: "center", value: "semestre" },
      { text: "Trilha de Aprendizagem", align: "center", value: "trilha" },
      { text: "Ativo", align: "center", value: "ativo" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ],
    selecionadosIds: []
  }),
  computed: {
    indeterminate() {
      const total = this.form.lists.listTrilhasDeAprendizagem.length;
      const selecionados = this.selecionadosIds.length;
      return selecionados > 0 && selecionados < total;
    }
  },
  methods: {
    openDialogManterTrilhasDeAprendizagem(trilha) {
      trilha
        ? this.$obterDadosTrilhaDeAprendizagem(trilha).then(({ data }) => {
            this.dialogManterTrilhaDeAprendizagem.open(new TrilhaDeAprendizagem(data.trilhaAprendizagem).format(), true);
          })
        : this.dialogManterTrilhaDeAprendizagem.open(TrilhaDeAprendizagem.Build())
    },
    openDialogVisualizarTrilhaDeAprendizagem(trilha) {
      this.$obterDadosTrilhaDeAprendizagem(trilha).then(
        ({ data }) => (this.dialogVisualizarTrilhaDeAprendizagem.open(data.trilhaAprendizagem))
      );
    },
    buscarTrilhasDeAprendizagem() {
      this.$buscarTrilhasDeAprendizagem(this.$montarParamsFilters(this.form.filters)).then(
        ({ data }) => {
          this.form.lists.listTrilhasDeAprendizagem = data.trilhasAprendizagem;
          this.selecionadosIds = [];
          this.marcarTodos = false;
        }
      );
    },
    inativarAtivarTrilhaDeAprendizagem(trilha) {
      this.$swal({
        text: `Deseja ${trilha.ativo ? "inativar" : "ativar"} a Trilha de Aprendizagem?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarTrilhaDeAprendizagem({ ...trilha, ativo: !trilha.ativo }, trilha.id).then(
          ({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarTrilhasDeAprendizagem();
          });
      });
    },
    resetForm() {
      this.$resetForm();
      this.form.lists.listTrilhasDeAprendizagem = [];
      this.marcarTodos = false;
    },
    // Lógica de checkbox
    marcarTodosItens() {
      if (this.marcarTodos) {
        this.selecionadosIds = this.form.lists.listTrilhasDeAprendizagem.map(t => t.id);
      } else {
        this.selecionadosIds = [];
      }
    },
    atualizarMarcarTodos() {
      const total = this.form.lists.listTrilhasDeAprendizagem.length;
      const selecionados = this.selecionadosIds.length;
      this.marcarTodos = (selecionados === total);
    },
    // Alterar status em lote
    async alterarStatusSelecionados() {
      const selecionados = this.form.lists.listTrilhasDeAprendizagem
      .filter(t => this.selecionadosIds.includes(t.id))

      if (!selecionados.length) {
        this.$notifyError("Nenhuma trilha selecionada!")
        return
      }

      const todosAtivos = selecionados.every(t => t.ativo)
      const ativo = !todosAtivos

      const trilhasSelecionadas = selecionados.map(t => ({
        id: t.id,
        ano: t.ano,
        semestre: t.semestre
      }))

      const payload = {
        trilhas: trilhasSelecionadas,
        ativo
      }

      this.$swal({
        text: `Deseja ${ativo ? "ativar" : "inativar"} as Trilhas de Aprendizagem selecionadas?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then(async () => {
        try {
          const { data } = await this.$api().patch("/v1/TrilhaAprendizagem/lote", payload)
          this.$notifySuccess(data.mensagem)
          this.buscarTrilhasDeAprendizagem()
        } catch (err) {
          this.$notifyError(err.response?.data?.mensagem || "Erro desconhecido")
        }
      })
    },
    toggleItem(id) {
        if (this.selecionadosIds.includes(id)) {
          this.selecionadosIds = this.selecionadosIds.filter(i => i !== id);
        } else {
          this.selecionadosIds = [...this.selecionadosIds, id];
        }

        this.atualizarMarcarTodos();
      }
  },
  mounted() {
    this.buscarTrilhasDeAprendizagem();
  }
};
</script>